export enum CustomLinkEvent {
  IMAGE_CLICK = "Image Click",
  TEXT_CLICK = "Text Click",
  PRODUCT_SEARCH_CARD_CLICK = "Product Search Card Click",
}
